export const getLayoutIsWhiteLabelUrl = state => state.layout.isWhiteLabelUrl;

